var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServiceIconcomponent = function SvgServiceIconcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5.25c0 .21-.045.412-.12.593 2.932.607 5.167 3.104 5.37 6.157H2.25c.203-3.053 2.438-5.55 5.37-6.157A1.504 1.504 0 0 1 9 3.75c.825 0 1.5.675 1.5 1.5Zm6 9v-1.5h-15v1.5h15Z",
    fill: "#CECCC9"
  })));
};
export default SvgServiceIconcomponent;